export const BAN_TYPES = {
  PUBLISH: 'publish',
  COMMENT: 'comment',
  REACTION: 'reaction',
  MESSAGE: 'message',
  FULL: 'full',
};

export const BAN_TYPE_LABELS = {
  [BAN_TYPES.PUBLISH]: 'حظر النشر',
  [BAN_TYPES.COMMENT]: 'حظر التعليق',
  [BAN_TYPES.REACTION]: 'حظر التفاعل',
  [BAN_TYPES.MESSAGE]: 'حظر الرسائل',
  [BAN_TYPES.FULL]: 'حظر دائم',
};

export const BAN_CREATOR_ROLES = [
  'المشرف العام',
  'نائب المشرف العام',
  'مسؤول قسم المحتوى',
];

export const BAN_PERMANENT_ROLES = [
  'المشرف العام',
  'نائب المشرف العام',
  'مسؤول قسم المحتوى',
  'مشرف المحتوى',
];

export const BAN_REMOVAL_ROLES = BAN_CREATOR_ROLES;

export const isActiveBanRecord = (ban, now = Date.now()) => {
  if (!ban || typeof ban !== 'object') return false;
  if (ban.active === false || ban.revoked === true) return false;
  if (ban.permanent === true) return true;
  if (ban.expiresAt === null || typeof ban.expiresAt === 'undefined') return true;
  const expiresAt = Number(ban.expiresAt);
  if (Number.isNaN(expiresAt)) return false;
  return expiresAt > now;
};

export const getActiveBanRecord = (userData, banType, now = Date.now()) => {
  const bans = userData?.bans;
  if (!bans || typeof bans !== 'object') return null;
  const ban = bans[banType];
  return isActiveBanRecord(ban, now) ? ban : null;
};

export const hasActiveBan = (userData, banType, now = Date.now()) => !!getActiveBanRecord(userData, banType, now);

export const getBanDurationMs = (amount, unit) => {
  const numericAmount = Number(amount);
  if (!numericAmount || numericAmount <= 0) return 0;
  if (unit === 'months') return numericAmount * 30 * 24 * 60 * 60 * 1000;
  return numericAmount * 24 * 60 * 60 * 1000;
};

export const buildBanPayload = ({
  banType,
  reason = '',
  durationMode = 'permanent',
  durationAmount = 1,
  durationUnit = 'days',
  createdBy = null,
  createdByRole = null,
}) => {
  const now = Date.now();
  const permanent = durationMode === 'permanent';
  const durationMs = permanent ? null : getBanDurationMs(durationAmount, durationUnit);
  const expiresAt = permanent || !durationMs ? null : now + durationMs;

  return {
    active: true,
    type: banType,
    reason: reason.trim() || '',
    createdAt: now,
    updatedAt: now,
    createdBy,
    createdByRole,
    permanent,
    expiresAt,
    durationMode,
    durationAmount: permanent ? null : Number(durationAmount),
    durationUnit: permanent ? null : durationUnit,
  };
};

export default {
  BAN_TYPES,
  BAN_TYPE_LABELS,
  BAN_CREATOR_ROLES,
  BAN_PERMANENT_ROLES,
  BAN_REMOVAL_ROLES,
  isActiveBanRecord,
  getActiveBanRecord,
  hasActiveBan,
  getBanDurationMs,
  buildBanPayload,
};